import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/footer';
import Home from './pages/Home';
import About from './pages/About'; // Kotha About page import chesam
import Contact from './pages/Contact';
import ComingSoon from './pages/ComingSoon';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen font-sans bg-[#f8fafc]">
        <Navbar />
        
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            
            {/* About Route Update: ComingSoon theesesi About component pettanu */}
            <Route path="/about" element={<About />} />
            
            <Route path="/contact" element={<Contact />} />
            <Route path="/services" element={<ComingSoon pageName="Our Services" />} />
            <Route path="/partners" element={<ComingSoon pageName="Our Partners" />} />
            <Route path="/careers" element={<ComingSoon pageName="Careers" />} />
          </Routes>
        </div>

        <Footer />
      </div>
    </Router>
  );
}

export default App;